import AddMachine from './AddMachine'

export default AddMachine
